<template>
  <v-container fluid class="fill-height">
    <v-card class="fill-height idcs-fill-width idcs-main-list back-img">
      <v-card-title>
        <i18n path="title.finance" class="text-h4 text-uppercase text-decoration-underline"></i18n>
        <v-spacer></v-spacer>
        <span class="mr-4">
          <DateRange v-model="dates" />
        </span>
        <span>
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search" clearable :label="$t('label.search')"></v-text-field>
        </span>
      </v-card-title>
      <v-card-text>
        <v-row align="center">
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <span v-on="on">
                <i18n path="label.bilance" class="pl-7 text-uppercase success--text">
                  <template #bilance>
                    <span class="title mr-6">{{bilance|currency}}</span>
                  </template>
                </i18n>
              </span>
            </template>
            <span>
              <i18n path="tooltip.available" />
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <span v-on="on">
                <i18n v-if="reserved" path="label.reserved" class="pl-7">
                  <template #reserved>
                    <span>{{reserved|currency}}</span>
                  </template>
                </i18n>
              </span>
            </template>
            <span>
              <i18n path="tooltip.reserved" />
            </span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip v-if="limit" bottom>
            <template v-slot:activator="{on}">
              <span v-on="on">
                <v-icon color="primary">mdi-information-outline</v-icon>
                <i18n path="label.limit" class="ml-2 pr-7 text-capitalize primary--text" v-on="on">
                  <template #limit>
                    <span class="title">{{limit|currency}}</span>
                  </template>
                </i18n>
              </span>
            </template>
            <span>
              <i18n path="tooltip.limit" />
            </span>
          </v-tooltip>
        </v-row>
        <v-data-table
          :items="filteredItems"
          :headers="headers"
          :search="search"
          class="idcs-main-list transparent"
          :footer-props="foot_props"
          :no-data-text="$t('label.nodata')"
        >
          <template
            v-slot:item.recipients="{item}"
          >{{item.recipients.items?item.recipients.items.length:0}}</template>
          <template v-slot:item.task="{item}">
            <v-btn v-if="item.task" icon :to="'/taskf/'+item.task" color="primary">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.created="{item}">{{item.created|dt-time}}</template>
          <template v-slot:item.amount="{item}">
            <div class="font-weight-bold">
              <span :class="item.amount>0?'success--text':'error--text'">{{item.amount>0?"+":""}}</span>
              <span :class="item.amount>0?'success--text':'error--text'">{{item.amount|currency}}</span>
            </div>
          </template>
          <template v-slot:item.remain="{item}">
            <span>{{item.remain|currency}}</span>
          </template>
          <!-- <template v-slot:body.append="{headers}">
            <tr>
              <td v-if="limit" :colspan="headers.length" align="right" class="success--text">
                <i18n path="label.limit" class="text-lowercase">
                  <template #limit>
                    <span class="title end-debit ml-4 pa-2 mr-n2">{{limit|currency}}</span>
                  </template>
                </i18n>
              </td>
            </tr>
            <tr>
              <td :colspan="headers.length" align="right" class="success--text">
                <i18n path="label.bilance" class="text-lowercase">
                  <template #bilance>
                    <span class="title end-debit ml-4 pa-2 mr-n2">{{bilance|currency}}</span>
                  </template>
                </i18n>
              </td>
            </tr>
          </template>-->
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import DateRange from "@/components/DateRange.vue";

export default {
  name: "Finance",
  mixins: [commonmixin],
  components: { DateRange },
  data() {
    return {
      menu: false,
      limit: 0,
      reserved: 0,
      dates: [],
      items: [],
      bilance: 0,
      headers: [
        {
          text: this.$t("fields.sourcetask"),
          value: "task",
          sortable: false,
          width: 170
        },
        {
          text: this.$t("fields.created"),
          value: "created",
          width: 150,
          align: "center",
          sortable: false
        },
        { text: this.$t("fields.comment"), value: "comment", sortable: false },
        {
          text: this.$t("fields.amount"),
          value: "amount",
          width: 120,
          sortable: false,
          align: "right"
        },
        {
          text: this.$t("fields.remain"),
          value: "remain",
          width: 120,
          sortable: false,
          align: "right"
        }
      ]
    };
  },
  computed: {
    filteredItems() {
      if (this.dates.length == 2) {
        return this.items.filter(e => {
          const d0 = this.$moment(e.created);
          let d1 = this.$moment(this.dates[0]);
          let d2 = this.$moment(this.dates[1]);
          if (d1.isAfter(d2)) {
            d1 = this.$moment(this.dates[1]);
            d2 = this.$moment(this.dates[0]);
          }
          let res =
            d0.isAfter(d1.startOf("day")) && d0.isBefore(d2.endOf("day"));
          return res;
        });
      } else {
        return this.items;
      }
    },
    dateRangeText() {
      return this.dates.join(" ~ ");
    }
  },
  methods: {
    loadData() {
      this.$api.getFinance().then(response => {
        this.bilance = response.bilance;
        this.limit = response.limit;
        this.items = response.data;
        this.reserved = response.reserved;
      });
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style scoped>
.back-img {
  background-image: url("../../public/img/file_euro.svg");
  background-size: 450px;
  background-repeat: initial;
}
.end-debit {
  border: solid 1px;
  border-radius: 10px;
}
.picker-class >>> input {
  width: 100px;
}
</style>